import React from 'react'
import { getImgSrc } from '../../services/common/CommonUtils';

function GoUp({ psmItem }) {

    const handleScroll = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    }

    return (
        <div class="pg-top-scroll-comp mt-5" onClick={handleScroll}>
            <div class="top-scroll-btn">
                {psmItem?.elementmeta?.title} <img src={getImgSrc('/assets/images/drop-down-button.svg')} alt="arrow-down" />
            </div>
        </div>
    )
}

export default GoUp